import React from 'react';

const focusAreas = [
    'Pembangunan jalan tol dan sistem transportasi untuk meningkatkan mobilitas dan mengurangi biaya logistik.',
    'Pembangkit listrik dan infrastruktur energi untuk menjamin keamanan dan kemandirian energi.',
    'Pelabuhan dan bandara guna memperkuat kapasitas perdagangan internasional Indonesia.',
    'Infrastruktur telekomunikasi dan digital, seperti Proyek Palapa Ring, yang bertujuan menyediakan akses internet hingga daerah terpencil dan kurang terlayani.',
];

function ProyekStrategisNasional() {
    return (
        <div className="py-4 lg:py-6">
            <div className="overflow-hidden rounded-[30px] border border-slate-200 bg-white shadow-[0_22px_60px_rgba(15,23,42,0.08)]">
                <div className="grid lg:grid-cols-[0.82fr_1.18fr]">
                    <div className="bg-gradient-to-br from-slate-950 via-[#0a213a] to-[#07598e] p-7 text-white sm:p-9 lg:p-11">
                        <span className="text-xs font-semibold uppercase tracking-[0.24em] text-blue-300">Konektivitas Nasional</span>
                        <h2 className="mt-4 text-3xl font-bold leading-tight sm:text-4xl">Proyek Strategis Nasional</h2>
                        <p className="mt-6 text-base leading-8 text-slate-200">
                            <strong className="text-white">Proyek Strategis Nasional (PSN)</strong> adalah inisiatif yang diluncurkan oleh Pemerintah Indonesia untuk mempercepat pembangunan proyek-proyek infrastruktur strategis di berbagai sektor penting di seluruh Indonesia. Program ini bertujuan mendorong pertumbuhan ekonomi nasional dengan memperbaiki infrastruktur transportasi, energi, perumahan, pengelolaan air, dan infrastruktur digital.
                        </p>
                    </div>
                    <div className="p-6 sm:p-8 lg:p-10">
                        <h3 className="text-xl font-bold text-slate-950">Fokus pembangunan dalam PSN</h3>
                        <div className="mt-5 grid gap-3 sm:grid-cols-2">
                            {focusAreas.map((area, index) => (
                                <article key={area} className="rounded-2xl border border-slate-200 bg-slate-50 p-5">
                                    <span className="text-xs font-bold text-blue-600">0{index + 1}</span>
                                    <p className="mt-2 text-sm leading-7 text-slate-600">{area}</p>
                                </article>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="grid gap-5 border-t border-slate-200 p-6 sm:p-8 lg:grid-cols-2 lg:p-10">
                    <p className="text-sm leading-7 text-slate-600 sm:text-base">
                        Melalui PSN, pemerintah berharap dapat mengatasi kesenjangan infrastruktur di berbagai wilayah Indonesia, terutama wilayah yang terpencil dan terpisah oleh geografis yang beragam. Program ini juga berfungsi meningkatkan produktivitas nasional dan memastikan pembangunan yang berkelanjutan, sekaligus mempersiapkan Indonesia agar lebih kompetitif dalam perekonomian global.
                    </p>
                    <p className="text-sm leading-7 text-slate-600 sm:text-base">
                        PSN tidak hanya berfokus pada pembangunan fisik, tetapi juga bertujuan meningkatkan kesejahteraan masyarakat melalui penciptaan lapangan kerja, penurunan tingkat kemiskinan, serta mempercepat konektivitas antara pulau-pulau di seluruh Nusantara.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default ProyekStrategisNasional;
